<header class="site-head">
  <div class="container">
    <div class="row justify-content-between align-items-end large-header">
      <div class="col-fit">
        <h1 class="sr-only">Collections Information Repository</h1>
        <a [routerLink]="'/'" aria-label="Home" role="link"><img src="../../../assets/images/CIR_Logo.png" alt="Logo for Collections Information Repository" class="cir-logo"></a>
      </div>
      <div class="col-md nav-items">
        <a role="button" class="button login cir" href="{{ loginUrl }}">Login</a>
      </div>
    </div>
  </div>
</header>
